import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { CATALOG_SORT, CATALOG_PAGE } from 'lib/core/resources/constants'
import { useProductListPage } from 'lib/modules/catalog'
import { Pagination } from 'lib/shared'
import { LateralMenu } from 'lib/ui'
import { CategorySort } from 'components/CategorySort'
import { LayeredNavMobile } from 'components/LayeredNavMobile'
import { ReactComponent as ArrowLeft } from 'resources/svg/icons/pagination-left.svg'
import { ReactComponent as ArrowRight } from 'resources/svg/icons/pagination-right.svg'
import { Container, TotalCountContainer, SorterContainer, LayeredNavButton } from './styled'
import { PaginationWrapper } from 'components/PaginationStyles'
import { ReactSelectTheme } from 'components/ReactSelectTheme'

interface Props {
  showTotalCount?: boolean
  showSorter?: boolean
  showPagination?: boolean
  categoryId?: number
  showLayeredNavAction?: boolean
  isDraft?: boolean
  isMulti?: boolean
  onChange?: () => void
  isBrand?: boolean
  title?: string
}

export const LayeredControls = ({
  categoryId,
  showPagination = true,
  showSorter = true,
  showTotalCount = true,
  showLayeredNavAction = true,
  isDraft = true,
  isMulti = true,
  onChange,
  isBrand = false,
  title
}: Props) => {
  const {
    isFetching,
    pageInfo,
    totalCount,
    handleFilterChange
  } = useProductListPage({ categoryId })

  const intl = useIntl()
  const [layeredNavVisible, setLayeredNavVisible] = useState(false)
  const renderPagination = ((pageInfo?.totalItems ?? 0) > (pageInfo?.pageSize ?? 0))

  function handleSortChange (e: any) {
    handleFilterChange({
      requestVar: CATALOG_SORT.SORT_BY,
      value: e.value
    })
    onChange?.()
  }

  function handlePageChange (e: number) {
    handleFilterChange({
      requestVar: CATALOG_PAGE.PAGE,
      value: [e.toString()]
    })
    onChange?.()
  }

  return (
    <>
      <Container
        isFetching={isFetching}
      >
        <div>
          {!!totalCount && (
            <>
              {showLayeredNavAction && (
                <LayeredNavButton>
                  <button
                    type='button'
                    onClick={() => setLayeredNavVisible(true)}
                  >
                    {intl.formatMessage({ id: 'catalog.productList.action.viewFilters' })}
                  </button>
                </LayeredNavButton>
              )}

              {showTotalCount && (
                <TotalCountContainer>
                  {!isBrand && (
                    <h2>{title}</h2>
                  )}
                  <span>{intl.formatMessage({ id: 'catalog.productList.totalCount' }, { totalCount })}</span>
                </TotalCountContainer>
              )}

              {showSorter && (
                <SorterContainer>
                  <ReactSelectTheme>
                    <CategorySort
                      categoryId={categoryId ?? 0}
                      handleSortChange={handleSortChange}
                    />
                  </ReactSelectTheme>
                </SorterContainer>
              )}

              {showPagination && renderPagination && (
                <>
                  <PaginationWrapper>
                    {pageInfo && (
                      <Pagination
                        currentPage={pageInfo.currentPage}
                        pageSize={pageInfo.pageSize}
                        totalItems={pageInfo.totalItems}
                        onChange={handlePageChange}
                        prevPageContent={<ArrowLeft />}
                        nextPageContent={<ArrowRight />}
                        firstPageContent=''
                        lastPageContent=''
                      />
                    )}
                  </PaginationWrapper>
                </>
              )}
            </>
          )}
        </div>

        <LateralMenu
          isVisible={layeredNavVisible}
          onOverlayClick={() => setLayeredNavVisible(false)}
        >
          <LayeredNavMobile
            isDraft={isDraft}
            isMulti={isMulti}
            categoryId={categoryId}
            onApplyFilters={() => {
              setLayeredNavVisible(false)
              if (onChange) {
                setTimeout(onChange, 500)
              }
            }}
          />
        </LateralMenu>
      </Container>
    </>
  )
}
